import styled from 'styled-components';

export const ControlBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  margin-top: 5vh;
  margin-bottom: 5vh;
`;
